import { render, staticRenderFns } from "./AppLoadingScreen.vue?vue&type=template&id=e645b70c&scoped=true"
import script from "./AppLoadingScreen.vue?vue&type=script&lang=js"
export * from "./AppLoadingScreen.vue?vue&type=script&lang=js"
import style0 from "./AppLoadingScreen.vue?vue&type=style&index=0&id=e645b70c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e645b70c",
  null
  
)

export default component.exports